import { Grid, TableCell, TableRow, Typography } from "@mui/material";
import { ReactNode } from "react";
import "./css/detailsLayout.scss";
import { IError } from "itsf-ui-common";
import { Loader } from "@common/Loader/Loader";

interface IParams {
    children: ReactNode;
    error?: IError;
    hasDetails: boolean;
    isLoading: boolean;
}

export const DetailsLayout = (props: IParams) => {
    const { children, error, hasDetails, isLoading } = props;

    return (
        <TableRow className="transaction-details">
            <TableCell colSpan={5}>
                {isLoading && <Loader />}
                {error && (
                    <Typography align="center" color="error">
                        {error.errorMessage}
                    </Typography>
                )}
                {!isLoading && !error && hasDetails && (
                    <Grid container spacing={2}>
                        {children}
                    </Grid>
                )}
            </TableCell>
        </TableRow>
    );
};
